import React, { useEffect } from 'react'
import { useAuthContext } from '../../contexts/AuthContext'
import { Navigate, useNavigate } from 'react-router-dom'

const Protected = ({ children }) => {

  const { isAuthenticated } = useAuthContext()

  if(isAuthenticated) {
    return children
  }
  else {
    return <Navigate to={'/login'}/>
  }
}

export default Protected